import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  // Firebase web configuration identifies the public client application; it is
  // intentionally available in the browser bundle. Environment variables may override it.
  apiKey: process.env.REACT_APP_API_KEY || 'AIzaSyAh0Zhxt_sAbAtMeW_gb0-QOaT1u7KHZH8',
  authDomain: process.env.REACT_APP_AUTH_DOMAIN || 'visualp-1.firebaseapp.com',
  databaseURL: process.env.REACT_APP_DATABASE_URL || 'https://visualp-1-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: process.env.REACT_APP_PROJECT_ID || 'visualp-1',
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET || 'visualp-1.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID || '659233295218',
  appId: process.env.REACT_APP_APP_ID || '1:659233295218:web:bc8889bbdcd00a4f372beb',
  measurementId: process.env.REACT_APP_MEASUREMENT_ID || 'G-T34PEL0VS4'
};

const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
export const auth = getAuth(app);
